import type { StripeCardNumberElement } from "@stripe/stripe-js";

export const PAYMENT_START_ERROR =
  "Unable to start the payment. Please try again.";

export const PAYMENT_CONFIRMATION_ERROR =
  "Unable to complete the payment. Please try again.";

export const getClientSecret = (response: unknown): string | null => {
  const clientSecret = (response as any)?.body?.data?.client_secret;

  return typeof clientSecret === "string" && clientSecret.trim()
    ? clientSecret
    : null;
};

// The PaymentIntent a failed confirmation belongs to. Stripe names it on the
// error when it has one; otherwise it is the part of the client secret before
// "_secret_".
export const getFailedIntentId = (
  error: any,
  clientSecret: string
): string | null => {
  const id = error?.payment_intent?.id || clientSecret.split("_secret_")[0];

  return typeof id === "string" && /^pi_[A-Za-z0-9]+$/.test(id) ? id : null;
};

let storedCardElement: StripeCardNumberElement | null = null;

export const setStoredCardElement = (
  cardElement: StripeCardNumberElement | null
) => {
  storedCardElement = cardElement;
};

export const getStoredCardElement = () => storedCardElement;

export const clearStoredCardElement = () => {
  storedCardElement = null;
};
